let GoldMatchRedirector = xClass("GoldMatchRedirector", BaseRedirector)
GoldMatchRedirector.prototype.getName = function () {
    return "goldMatch"
}
GoldMatchRedirector.prototype.redirect = function () {
    let self = this
    let param = self.param
    let scene = cc.Director.getInstance().getRunningScene()
    if (!scene || scene.name === 'PreloadScene') {
        return false
    } else {
        let inHome = scene && scene.name === "HomeScene"
        let uid = UserManager.getInstance().uid
        let isMyself = param["inviteCode"] && +param["inviteCode"] === uid || false
        let lastPanel = PopoutManager.getLastPopoutPanel()
        let isGlodMatchPanelPopup = lastPanel && lastPanel.class.__cname === "GoldMatchPanel"
        let isGoldMatch = self.param["type"] && self.param["type"] === self.getName()
        // let logic = require("activity/GoldMatchActivity/GoldMatchActivityLogic").getInstance()
        let logic = GoldMatchActivityLogic.getInstance()

        if (!isGoldMatch) {
            return  true
        }
        if (!logic.isActivityOpen()) {
            Toast.make(getText("goldmatch.activity.overed"))
            return true
        }
        if (isMyself) {
            Toast.make(getText("goldmatch.activity.help.not.self"))
            return true
        }
        if (!_G.kIsNewUser) {
            Toast.make(getText("goldmatch.activity.help.not.newuser"))
            return true
        }
        let inviteCode = +param["inviteCode"]
        if ((isGlodMatchPanelPopup || !inHome || _G.kIsNewUser)) { //新用户需要先做新手引导，进来帮对方把步数加了但是不弹窗
            logic.helpFriendGetTimes(inviteCode)
            return true
        }else {
            return new Promise((resolve) => {
                logic.showPanel({
                    uid: inviteCode
                }, resolve)
                DCAssist.dc4ClickIcon("goldMode", "click_icon")
            })
        }
    }
}

GoldMatchRedirector.prototype.hasHighPriorityAction = function () {
    return false
}

module.exports = GoldMatchRedirector